module.exports = __webpack_public_path__ + "img/banner.725a79e9.png";